<template lang="pug">
.flex.flex-col.additional-info#AdditionalInfoBlockVue(:class="{'mt-9': $store.state.country.code === 'DE'}")
  .flex.flex-col(v-show="!buttonOnly")
    Basket.mb-7(v-if="isMobile", :inplace="true")
    h3.text-lg.font-medium(class="lg1024:text-3xl", v-if="!isHiddenCommentBlock") {{ $t('additional_info_block_title') }}
    textarea.mt-4.border.border-gray-1.p-3.mb-6(v-model="data.orderComment", rows="7", :placeholder="$t('additional_info_block_comment_placeholder')", v-if="!isHiddenCommentBlock", data-qa="additional-info-comment-input")

    UiCheckbox.additional-info__email-checkbox.mb-3(v-model="data.receiveEmails" :class="{'mt-4': isMobile}", data-qa="additional-info-receive-emails-checkbox")
      p.checkbox-label {{ $t('additional_info_block_receive_emails') }}

    a(analytics-id="analytics-160", v-if="!isMobile")
      UiCheckbox.additional-info__accept-terms-checkbox(v-model="data.acceptTerms", :error="acceptError && !data.acceptTerms", alignItems="start", data-qa="additional-info-accept-terms-checkbox")
        p.checkbox-label(v-html="termText")
  a(analytics-id="analytics-160", v-if="isMobile")
    UiCheckbox.additional-info__accept-terms-checkbox-mobile(v-show="!buttonOnly", v-model="data.acceptTerms", :error="acceptError", data-qa="additional-info-accept-terms-checkbox-mobile")
      p.checkbox-label(v-html="termText")

  UiCheckbox.mt-3.text-accentColor(
    v-if="isProcessingCheckboxVisible"
    v-model="data.agreePersonalData",
    alignItems="start",
    data-qa="additional-info-agree-personal-data-checkbox"
  )
    p.checkbox-label(v-html="$t('checkout_processing_data')")

  .flex.flex-col.items-start(:class="{ 'mt-6': !buttonOnly}")
    .text-red-500(v-if="hasApiError", data-qa="additional-info-api-errors")
      div(v-for="(error, index) in apiErrors", :key="index" v-show="Array.isArray(apiErrors)") {{ getError(error) }}
      div(v-show="apiErrors === 'Empty basket'") {{ getError(apiErrors) }}
    .text-red-500(v-if="acceptError", data-qa="additional-info-accept-error")
      p {{ $t('fill_all') }}
    UiButton.additional-info__button.mb-5(class="max-w-[328px] max-sm:max-w-[100%]" size="xl" @click="order()", :disabled="isPaymentButtonDisabled", data-qa="additional-info-order-btn")
      p {{ orderButtonText }}
      .loader
        Loader
    small.text-gray-3(v-html="$t('additional_info_small')")
</template>

<script>
import Basket from './Basket.vue'
import Loader from './Loader.vue'
import { mapState, mapGetters } from 'vuex'
import UiButton from '@/components/ui/UiButton.vue'
import UiCheckbox from '@/components/ui/UiCheckbox.vue'

export default {
  name: 'AdditionalInfoBlock',
  components: { Basket, UiCheckbox, UiButton, Loader },
  props: {
    buttonOnly: {
      type: Boolean,
      default: false,
    },
    canSend: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      data: {
        orderComment: '',
        needToContact: false,
        contactMethod: '',
        chosenMessenger: '',
        receiveEmails: false,
        acceptTerms: false,
        acceptTerms2: false,
        agreePersonalData: false,
      },
      acceptError: false,
      deTerms1: false,
      deTerms2: false,
      contactMethods: [
        {
          ID: 'additional_info_phone',
          NAME: this.$t('additional_info_block_need_to_contact_phone'),
        },
        {
          ID: 'additional_info_sms',
          NAME: this.$t('additional_info_block_need_to_contact_sms'),
        },
        {
          ID: 'additional_info_messenger',
          NAME: this.$t('additional_info_block_need_to_contact_messenger'),
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      isUseCoralWallet: 'wallet/isUseCoralWallet',
      orderData: 'getOrderData',
    }),
    ...mapGetters([
      'getActivePaymentType',
      'isHiddenCommentBlock',
      'getCountryCode',
      'apiErrors',
      'hasApiError',
    ]),
    ...mapState({ loading: 'loading' }),

    isOrderFullyPaidByWallet() {
      return (
        this.isUseCoralWallet &&
        Number(this.orderData?.TOTAL_PRICE_WITH_PROMO) === 0
      )
    },
    orderButtonText() {
      if (this.isOrderFullyPaidByWallet) {
        return this.$t('additional_button_place_order')
      }
      return this.$t('additional_button')
    },

    termText() {
      return (
        this.$t(
          'additional_info_term1_text_' +
            this.$store.state.country.code.toLowerCase()
        ) ?? this.$t('additional_info_term1_text_other')
      )
    },
    isMobile() {
      return this.$isMobile
    },
    isPaymentButtonDisabled() {
      return (
        !this.data.acceptTerms ||
        !this.canSend ||
        (this.isProcessingCheckboxVisible && !this.data.agreePersonalData)
      )
    },
    isProcessingCheckboxVisible() {
      return this.getCountryCode === 'RU' && !this.buttonOnly && !window.authed
    },
  },
  mounted() {
    this.data = this.$store.state.additionalOrderInfo
  },
  watch: {
    deTerms1() {
      if (this.deTerms1 && this.deTerms2) {
        this.data.acceptTerms = true
      } else {
        this.data.acceptTerms = false
      }
    },
    deTerms2() {
      if (this.deTerms1 && this.deTerms2) {
        this.data.acceptTerms = true
      } else {
        this.data.acceptTerms = false
      }
    },
    'data.acceptTerms': {
      handler() {
        this.acceptError = false
      },
    },
    'data.orderComment': {
      handler() {
        if (this.data.orderComment?.length > 1200)
          this.data.orderComment = this.data.orderComment.substring(0, 1200)
      },
    },
    'data.needToContact': {
      handler(newValue) {
        if (!newValue) {
          this.data.contactMethod = null
          this.data.chosenMessenger = null
        }
      },
    },
    'data.contactMethod': {
      handler(newValue) {
        if (newValue === 'additional_info_messenger') {
          this.data.chosenMessenger = 'Telegram'
        } else this.data.chosenMessenger = null
      },
    },
    data: {
      handler() {
        this.$store.commit('UpdateAdditionalOrderInfo', this.data)
      },
      deep: true,
    },
    isUseCoralWallet: {
      handler(newValue) {
        if (newValue) {
          this.acceptError = false
          this.$emit('acceptError', this.acceptError)
        }
      },
    },
  },
  methods: {
    order() {
      // Coral Wallet больше не блокирует оформление: решение по кошельку
      // необязательно, поэтому скролла-возврата к блоку CW здесь нет.
      if (
        this.data.acceptTerms &&
        this.canSend &&
        (!this.isProcessingCheckboxVisible ||
          (this.isProcessingCheckboxVisible && this.data.agreePersonalData))
      ) {
        this.$emit('order')
      } else {
        this.acceptError = false
        setTimeout(() => {
          this.acceptError = true
        }, 100)
      }
    },
    getError(error) {
      if (error === 'Empty basket') {
        return this.$t('error_checkout_empty_basket')
      } else {
        return error
      }
    },
  },
}
</script>

<style lang="scss" scoped>
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url('../assets/img/sorting-icon.png');
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 50%;
  height: 50px !important;
}
button.disabled {
  opacity: 0.4;
  /* pointer-events: none; */
}

.saveOrder {
  border-radius: 4px;
  font-family: Rubik, Arial, sans-serif !important;
}

.saveOrder:hover:not(.disabled) {
  background-color: #e4564d;
  border-color: #e4564d;
}

@keyframes error {
  0% {
    background: var(--cci-color-white);
  }
  10% {
    background: var(--cci-color-red);
  }
  50% {
    background: var(--cci-color-white);
  }
  51% {
    background: var(--cci-color-red);
  }
  100% {
    background: var(--cci-color-white);
  }
}

.checkbox-labeled.error {
  animation: error 1s linear 1;
}

.checkbox-labeled input {
  width: 16px;
  top: -1px;
}
.checkbox-labeled label {
  width: calc(100% - 0.5rem - 16px);
}

@media (max-width: 768px) {
  .saveOrder {
    width: 100%;
    max-width: 100%;
  }

  small {
    line-height: 14px;
  }

  .checkbox-labeled input {
    top: 2px;
  }
}
.top-checkbox {
  @media (max-width: 1024px) {
    margin-top: 0.25rem;
  }
}
.additional-button {
  p {
    &::first-letter {
      text-transform: capitalize;
    }
  }
}
</style>
